var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "wf-back-to-top-button button-full",
      class: _vm.statusClass,
      attrs: { type: "button", "aria-label": "Back to top" },
      on: { click: _vm.scrollToTop }
    },
    [
      _c("span", {
        staticClass: "png-icon png-icon-icons-glyph--k-scroll-b2top"
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }